<template>
  <div class="project-view-switcher">
    <!-- View content -->
    <div class="view-content">
      <ListProjects v-if="currentView === 'caseManagement'" />
      <ProjectManagement v-else-if="currentView === 'projectManagement'" />
    </div>
    
    <!-- Small toggle switch in corner -->
    <div class="view-toggle-switch">
      <b-tooltip 
        :label="currentView === 'projectManagement' ? 'Switch to Case Management View' : 'Switch to Project Management View'"
        position="is-left"
        type="is-dark"
      >
        <button 
          class="toggle-button" 
          @click="toggleView"
          :class="{ 'is-case-view': currentView === 'caseManagement' }"
        >
          <i class="fas fa-exchange-alt"></i>
        </button>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListProjects from './ListProjects.vue';
import ProjectManagement from './ProjectManagement.vue';

export default {
  name: 'ProjectViewSwitcher',
  components: {
    ListProjects,
    ProjectManagement
  },
  data() {
    return {
      currentView: 'projectManagement' // Default view, will be updated based on server config
    };
  },
  computed: {
    ...mapGetters('serverConfig', [
      'isFolderBasedEnabled',
      'isLoaded'
    ])
  },
  async mounted() {
    await this.initializeView();
  },
  methods: {
    ...mapActions('serverConfig', ['fetchServerConfig']),

    async initializeView() {
      try {
        // Fetch server config if not already loaded
        if (!this.isLoaded) {
          await this.fetchServerConfig();
        }

        // Set initial view based on server configuration
        // If folder-based is enabled, show projectManagement (folder view)
        // Otherwise, show caseManagement (case view)
        this.currentView = this.isFolderBasedEnabled ? 'projectManagement' : 'caseManagement';
      } catch (error) {
        console.error('Failed to initialize view based on server config:', error);
        // Fallback to default view
        this.currentView = 'projectManagement';
      }
    },

    toggleView() {
      this.currentView = this.currentView === 'projectManagement' ? 'caseManagement' : 'projectManagement';
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/dark-variables.scss';

.project-view-switcher {
  position: relative;
  height: 100%;
  
  .view-content {
    height: 100%;
  }
  
  .view-toggle-switch {
    position: fixed;
    bottom: 0.85rem;
    left: 0.85rem;
    z-index: 100;
    
    .toggle-button {
      background: rgba(8, 17, 29, 0.86);
      border: 1px solid rgba(190, 214, 238, 0.18);
      color: $dark-text-secondary;
      width: 34px;
      height: 34px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.24);
      backdrop-filter: blur(10px);
      
      &:hover {
        background-color: rgba($primary, 0.13);
        border-color: rgba($primary, 0.42);
        color: $primary;
        box-shadow: 0 14px 32px rgba(0, 0, 0, 0.28), 0 0 0 3px rgba($primary, 0.08);
      }
      
      &.is-case-view {
        background-color: rgba($primary, 0.17);
        border-color: rgba($primary, 0.5);
        color: $primary;
      }
      
      .fa-exchange-alt {
        font-size: 14px;
        transform: rotate(90deg);
      }
    }
  }
}
</style>
